export const SMS_RECAPTCHA_ID = 'recaptcha-sms'
